export const DateRangeEnums = {
  today: { name: 'Today', type: 'day', increment: 0 },
  tomorrow: { name: 'Tomorrow', type: 'day', increment: 1 },
  thisWeek: { name: 'This week', type: 'week', increment: 0 },
  nextWeek: { name: 'Next week', type: 'week', increment: 1 },
  thisMonth: { name: 'This month', type: 'month', increment: 0 },
  nextMonth: { name: 'Next month', type: 'month', increment: 1 },
};
